import type { RouteRecordRaw } from 'vue-router'
import ReceivedSms from '@/data/models/domain/ReceivedSms'
import type { SingleModelResolverParams } from '@/services/resolvers/types'
import InboundCall from '@/data/models/domain/InboundCall'
import OutboundCall from '@/data/models/domain/OutboundCall'
import ForwardedCall from '@/data/models/domain/ForwardedCall'
import SentSmsShort from '@/data/models/domain/SentSmsShort'
import { AppModule } from '@/config/types'
import type { OutboundEmailsTitlerServiceParams } from '@/services/domain/outboundEmails/outboundEmailsTitlerService'
import EmailCampaign from '@/data/models/domain/campaign/EmailCampaign'
import type SentSmsBulkDetails from '@/components/views/reporting/history/sms/sent/SentSmsBulkDetails.vue'
import type { ComponentProps } from '@/composition/types'
import type SentSmsBulkDetailsDelivered from '@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsDelivered.vue'
import PassThrough from '@/components/layout/PassThrough.vue'
import type SentSmsBulkDetailsOverview from '@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsOverview.vue'

export const userHistoryRouteName = 'user.history'

export const userHistorySentSmsRouteName = 'user.history.sentSms'

export const userHistoryReceivedSmsRouteName = 'user.history.receivedSms'

export const userHistoryOutboundEmailsRouteName = 'user.history.outboundEmails'

export const userHistoryOutboundEmailsDetailsRouteName = 'user.history.outboundEmailsDetails'

export const userHistoryOutboundEmailsBulkDetailsRouteName = 'user.history.outboundEmailsBulkDetails'

export const userHistoryOutboundEmailsBulkDetailsOverviewRouteName = 'user.history.outboundEmails.overview'
export const userHistoryOutboundEmailsBulkDetailsRecipientsRouteName = 'user.history.outboundEmails.recipients'
export const userHistoryOutboundEmailsBulkDetailsOpensRouteName = 'user.history.outboundEmails.opens'
export const userHistoryOutboundEmailsBulkDetailsClicksRouteName = 'user.history.outboundEmails.clicks'
export const userHistoryOutboundEmailsBulkDetailsClicksSummaryRouteName = 'user.history.outboundEmails.clicks.summary'
export const userHistoryOutboundEmailsBulkDetailsClicksAllRouteName = 'user.history.outboundEmails.clicks.all'
export const userHistoryOutboundEmailsBulkDetailsUnsubscribersRouteName = 'user.history.outboundEmails.unsubscribers'
export const userHistoryOutboundEmailsBulkDetailsSpamRouteName = 'user.history.outboundEmails.spam'

export const userHistorySentSmsDetailsRouteName = 'user.history.sentSmsDetails'

export const userHistorySentSmsBulkDetailsOverviewRouteName = 'user.history.sentSmsBulkDetailsOverview'

export const userHistorySentSmsBulkDetailsDeliveredRouteName = 'user.history.sentSmsBulkDetailsDelivered'

export const userHistorySentSmsBulkDetailsSentRouteName = 'user.history.sentSmsBulkDetailsSent'

export const userHistorySentSmsBulkDetailsFailedRouteName = 'user.history.sentSmsBulkDetailsFailed'

export const userHistorySentSmsBulkDetailsRejectedRouteName = 'user.history.sentSmsBulkDetailsRejected'

export const userHistorySentSmsBulkDetailsRouteName = 'user.history.sentSmsBulkDetails'

export const userHistoryReceivedSmsDetailsRouteName = 'user.history.receivedSmsDetails'

export const userHistoryForwardedCallsRouteName = 'user.history.forwardedCalls'

export const userHistoryOutboundCallsRouteName = 'user.history.outboundCalls'

export const userHistoryInboundCallsRouteName = 'user.history.inboundCalls'

export const userHistoryForwardedCallsDetailsRouteName = 'user.history.forwardedCalls.details'

export const userHistoryInboundCallsDetailsRouteName = 'user.history.inboundCalls.details'

export const userHistoryOutboundCallsDetailsRouteName = 'user.history.outboundCalls.details'

export const userHistorySmsRootRouteName = 'user.history.sms'
export const userHistorySmsInboundRouteName = 'user.history.sms.inbound'
export const userHistorySmsOutboundRouteName = 'user.history.sms.outbound'

export const userHistoryEmailsRootRouteName = 'user.history.emails'

export const userHistoryCallsRootRouteName = 'user.history.calls'
export const userHistoryCallsOutboundRouteName = 'user.history.calls.outbound'
export const userHistoryCallsInboundRouteName = 'user.history.calls.inbound'
export const userHistoryCallsForwardedRouteName = 'user.history.calls.forwarded'

export const getHistoryRoutes = (): RouteRecordRaw[] => [
  {
    name: userHistoryRouteName,
    path: 'history',
    redirect: { name: 'user.history.index' },
    meta: {
      tags: ['USER_TOP_MENU'],
      permission: 'history',
      modules: [
        AppModule.SenderSettingsCountries,
        AppModule.ContactsUnsubscribed,
        AppModule.ContactsBlocked,
        AppModule.ContactList,
        AppModule.Compose,
        AppModule.WhatsApp,
        AppModule.Facebook,
        AppModule.Instagram,
        AppModule.Labels,
      ],
    },
    children: [
      {
        name: 'user.history.index',
        path: '',
        redirect: { name: userHistorySmsOutboundRouteName },
        meta: {
          resolvers: [
            {
              service: 'FacetResolver',
              params: {
                model: SentSmsShort,
                subscriptionModels: [
                  SentSmsShort,
                  ReceivedSms,
                  ForwardedCall,
                  OutboundCall,
                  InboundCall,
                  EmailCampaign,
                ],
              },
            },
          ],
        },
        component: PassThrough,
        children: [
          {
            name: userHistoryEmailsRootRouteName,
            redirect: { name: userHistoryOutboundEmailsRouteName },
            path: 'outbound-emails',
            meta: {
              tags: ['HISTORY_BAR_LIST'],
              modules: [
                AppModule.SentSmsBase,
                AppModule.HistorySentSms,
                AppModule.TmTiptapEditor,
                AppModule.OutboundEmails,
                AppModule.Recipient,
                AppModule.ComposeEmail,
              ],
              resolvers: [{ service: 'EmailCampaignProgressResolver' }],
            },
            children: [
              {
                name: userHistoryOutboundEmailsRouteName,
                path: '',
                meta: {
                  tabTitle: 'pageTitle.user.history.outboundEmails',
                },
                component: () => import('@/components/views/reporting/history/OutboundEmails.vue'),
              },
              {
                name: userHistoryOutboundEmailsDetailsRouteName,
                path: ':campaignId/:emailId',
                props: (route) => {
                  return {
                    campaignId: route.params.campaignId,
                    emailId: route.params.emailId,
                  }
                },
                meta: {
                  resolverComponent: () => import('@/components/domain/history/OutboundEmailsDetailsResolver.vue'),
                  resolvers: [
                    {
                      service: 'OutboundEmailsResolverService',
                    },
                  ],
                  tabTitle: 'pageTabTitle.user.history.outboundEmail',
                  titler: {
                    service: 'OutboundEmailsTitlerService',
                    params: {
                      idKey: 'emailId',
                    } satisfies OutboundEmailsTitlerServiceParams<typeof userHistoryOutboundEmailsDetailsRouteName>,
                  },
                  fullHeight: true,
                  modules: [AppModule.Automations],
                },
                component: () => import('@/components/views/reporting/history/OutboundEmailsDetails.vue'),
              },
              {
                name: userHistoryOutboundEmailsBulkDetailsRouteName,
                path: 'session/:id',
                props: (route) => {
                  return {
                    id: route.params.id,
                  }
                },
                component: () => import('@/components/views/reporting/history/OutboundEmailsBulkDetails.vue'),
                redirect: { name: userHistoryOutboundEmailsBulkDetailsOverviewRouteName },
                meta: {
                  tabTitle: 'pageTabTitle.user.history.outboundEmail',
                  titler: {
                    service: 'OutboundEmailsTitlerService',
                    params: {
                      idKey: 'id',
                    } satisfies OutboundEmailsTitlerServiceParams<typeof userHistoryOutboundEmailsBulkDetailsRouteName>,
                  },
                  fullHeight: true,
                  resolverComponent: () => import('@/components/domain/history/OutboundEmailsBulkDetailsResolver.vue'),
                  resolvers: [
                    {
                      service: 'OutboundEmailsBulkResolverService',
                    },
                  ],
                },
                children: [
                  {
                    name: userHistoryOutboundEmailsBulkDetailsOverviewRouteName,
                    path: 'overview',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    meta: {
                      modules: [AppModule.Recipient, AppModule.CampaignsSenders, AppModule.Automations],
                    },
                    component: () =>
                      import('@/components/views/reporting/history/OutboundEmailsBulkDetailsOverview.vue'),
                  },
                  {
                    name: userHistoryOutboundEmailsBulkDetailsRecipientsRouteName,
                    path: 'recipients',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    component: () =>
                      import('@/components/views/reporting/history/OutboundEmailsBulkDetailsRecipients.vue'),
                  },
                  {
                    name: userHistoryOutboundEmailsBulkDetailsOpensRouteName,
                    path: 'opens',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    component: () => import('@/components/views/reporting/history/OutboundEmailsBulkDetailsOpens.vue'),
                  },
                  {
                    name: userHistoryOutboundEmailsBulkDetailsClicksRouteName,
                    path: 'clicks',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    component: () => import('@/components/views/reporting/history/OutboundEmailsBulkDetailsClicks.vue'),
                    redirect: { name: userHistoryOutboundEmailsBulkDetailsClicksSummaryRouteName },
                    children: [
                      {
                        name: userHistoryOutboundEmailsBulkDetailsClicksSummaryRouteName,
                        path: 'summary',
                        props: (route) => {
                          return {
                            id: route.params.id,
                          }
                        },
                        component: () =>
                          import('@/components/views/reporting/history/OutboundEmailsBulkDetailsClicksSummary.vue'),
                      },
                      {
                        name: userHistoryOutboundEmailsBulkDetailsClicksAllRouteName,
                        path: 'all',
                        props: (route) => {
                          return {
                            id: route.params.id,
                          }
                        },
                        component: () =>
                          import('@/components/views/reporting/history/OutboundEmailsBulkDetailsClicksAll.vue'),
                      },
                    ],
                  },
                  {
                    name: userHistoryOutboundEmailsBulkDetailsUnsubscribersRouteName,
                    path: 'unsubscribers',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    component: () =>
                      import('@/components/views/reporting/history/OutboundEmailsBulkDetailsUnsubscribers.vue'),
                  },
                  {
                    name: userHistoryOutboundEmailsBulkDetailsSpamRouteName,
                    path: 'spam',
                    props: (route) => {
                      return {
                        id: route.params.id,
                      }
                    },
                    component: () =>
                      import('@/components/views/reporting/history/OutboundEmailsBulkDetailsSpamReports.vue'),
                  },
                ],
              },
            ],
          },
          {
            name: userHistorySmsRootRouteName,
            path: 'sms',
            component: () => import('@/components/views/history/HistorySms.vue'),
            redirect: { name: userHistorySmsOutboundRouteName },
            children: [
              {
                name: userHistorySmsOutboundRouteName,
                path: 'outbound',
                alias: '/history/sent-sms',
                redirect: { name: userHistorySentSmsRouteName },
                meta: {
                  tags: ['HISTORY_BAR_LIST'],
                  modules: [AppModule.SentSmsBase, AppModule.HistorySentSms],
                },
                children: [
                  {
                    name: userHistorySentSmsRouteName,
                    path: '',
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.sentSms',
                    },
                    component: () => import('@/components/views/reporting/history/sms/sent/SentSms.vue'),
                  },
                  {
                    name: userHistorySentSmsDetailsRouteName,
                    path: ':sentSmsId',
                    props: true,
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.sentSmsDetails',
                      resolvers: [
                        {
                          service: 'OutboundSmsResolverService',
                        },
                      ],
                      resolverComponent: () => import('@/components/domain/history/HistoryDetailsResolver.vue'),
                      resolverComponentProps: {
                        loaderTitleKey: 'sentSmsDetailsInfoLoading.title',
                        loaderDescriptionKey: 'sentSmsDetailsInfoLoading.description',
                      },
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      fullHeight: true,
                      modules: [AppModule.Automations],
                    },
                    component: () => import('@/components/views/reporting/history/sms/sent/SentSmsDetails.vue'),
                  },
                  {
                    name: userHistorySentSmsBulkDetailsRouteName,
                    path: 'session/:sessionId',
                    props: (route) => {
                      return {
                        sessionId: route.params.sessionId,
                      } satisfies ComponentProps<typeof SentSmsBulkDetails>
                    },
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.sentSmsBulkDetailsSummary',
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      fullHeight: true,
                      modules: [AppModule.HistoryReceivedSms, AppModule.Automations],
                    },
                    component: () => import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetails.vue'),
                    redirect: { name: userHistorySentSmsBulkDetailsOverviewRouteName },
                    children: [
                      {
                        name: userHistorySentSmsBulkDetailsOverviewRouteName,
                        path: 'overview',
                        meta: {
                          modules: [AppModule.Recipient],
                        },
                        props: (route) => {
                          return {
                            sessionId: route.params.sessionId,
                          } satisfies ComponentProps<typeof SentSmsBulkDetailsOverview>
                        },
                        component: () =>
                          import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsOverview.vue'),
                      },
                      {
                        name: userHistorySentSmsBulkDetailsDeliveredRouteName,
                        path: 'delivered',
                        props: (route) => {
                          return {
                            sessionId: route.params.sessionId,
                          } satisfies ComponentProps<typeof SentSmsBulkDetailsDelivered>
                        },
                        component: () =>
                          import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsDelivered.vue'),
                      },
                      {
                        name: userHistorySentSmsBulkDetailsSentRouteName,
                        path: 'sent',
                        props: (route) => {
                          return {
                            sessionId: route.params.sessionId,
                          }
                        },
                        component: () =>
                          import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsSent.vue'),
                      },
                      {
                        name: userHistorySentSmsBulkDetailsFailedRouteName,
                        path: 'failed',
                        props: (route) => {
                          return {
                            sessionId: route.params.sessionId,
                          }
                        },
                        component: () =>
                          import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsFailed.vue'),
                      },
                      {
                        name: userHistorySentSmsBulkDetailsRejectedRouteName,
                        path: 'rejected',
                        props: (route) => {
                          return {
                            sessionId: route.params.sessionId,
                          }
                        },
                        component: () =>
                          import('@/components/views/reporting/history/sms/sent/SentSmsBulkDetailsRejected.vue'),
                      },
                    ],
                  },
                ],
              },
              {
                name: userHistorySmsInboundRouteName,
                redirect: { name: userHistoryReceivedSmsRouteName },
                path: 'inbound',
                alias: '/history/received-sms',
                meta: {
                  tags: ['HISTORY_BAR_LIST'],
                  modules: [AppModule.HistoryReceivedSms, AppModule.SentSmsBase],
                },
                children: [
                  {
                    name: userHistoryReceivedSmsRouteName,
                    path: '',
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.receivedSms',
                      modules: [AppModule.HistoryReceivedSms],
                    },
                    component: () => import('@/components/views/reporting/history/sms/received/ReceivedSms.vue'),
                  },
                  {
                    name: userHistoryReceivedSmsDetailsRouteName,
                    path: ':receivedSmsId',
                    props: true,
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.receivedSmsDetails',
                      modules: [AppModule.HistoryReceivedSms],
                      detailsPage: {
                        source: 'router',
                        requestParam: 'receivedSmsId',
                        model: ReceivedSms,
                      } as SingleModelResolverParams,
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      redirectToIfNotFound: { name: userHistoryReceivedSmsRouteName },
                      fullHeight: true,
                      resolverComponent: () => import('@/components/domain/history/HistoryDetailsResolver.vue'),
                      resolverComponentProps: {
                        loaderTitleKey: 'receivedSmsDetailsInfoLoading.title',
                        loaderDescriptionKey: 'receivedSmsDetailsInfoLoading.description',
                      },
                    },
                    component: () => import('@/components/views/reporting/history/sms/received/ReceivedSmsDetails.vue'),
                  },
                ],
              },
            ],
          },
          {
            name: userHistoryCallsRootRouteName,
            path: 'calls',
            component: () => import('@/components/views/history/HistoryCalls.vue'),
            redirect: { name: userHistoryCallsOutboundRouteName },
            children: [
              {
                name: userHistoryCallsForwardedRouteName,
                redirect: { name: userHistoryForwardedCallsRouteName },
                path: 'forwarded',
                alias: '/history/forwarded-calls',
                meta: {
                  tags: ['HISTORY_BAR_LIST'],
                  modules: [AppModule.ForwardedCalls],
                },
                children: [
                  {
                    name: userHistoryForwardedCallsRouteName,
                    path: '',
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.forwardedCalls',
                      modules: [AppModule.HistoryForwardedCalls, AppModule.SentSmsBase],
                    },
                    component: () => import('@/components/views/reporting/history/calls/forwarded/ForwardedCalls.vue'),
                  },
                  {
                    name: userHistoryForwardedCallsDetailsRouteName,
                    path: ':forwardedCallId',
                    props: true,
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.forwardedCallDetails',
                      detailsPage: {
                        source: 'router',
                        requestParam: 'forwardedCallId',
                        model: ForwardedCall,
                      } as SingleModelResolverParams,
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      redirectToIfNotFound: { name: userHistoryForwardedCallsRouteName },
                      fullHeight: true,
                      resolverComponent: () => import('@/components/domain/history/HistoryDetailsResolver.vue'),
                      resolverComponentProps: {
                        loaderTitleKey: 'callDetailsInfoLoading.title',
                        loaderDescriptionKey: 'callDetailsInfoLoading.description',
                      },
                    },
                    component: () =>
                      import('@/components/views/reporting/history/calls/forwarded/ForwardedCallsDetails.vue'),
                  },
                ],
              },
              {
                name: userHistoryCallsOutboundRouteName,
                redirect: { name: userHistoryOutboundCallsRouteName },
                path: 'outbound',
                alias: '/history/outbound-calls',
                meta: {
                  tags: ['HISTORY_BAR_LIST'],
                },
                children: [
                  {
                    name: userHistoryOutboundCallsRouteName,
                    path: '',
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.outboundCalls',
                      modules: [AppModule.HistoryOutboundCalls, AppModule.SentSmsBase],
                    },
                    component: () => import('@/components/views/reporting/history/calls/outbound/OutboundCalls.vue'),
                  },
                  {
                    name: userHistoryOutboundCallsDetailsRouteName,
                    path: ':outboundCallId',
                    props: true,
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.outboundCallDetails',
                      detailsPage: {
                        source: 'router',
                        requestParam: 'outboundCallId',
                        model: OutboundCall,
                      } as SingleModelResolverParams,
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      redirectToIfNotFound: { name: userHistoryOutboundCallsRouteName },
                      fullHeight: true,
                      modules: [AppModule.HistoryOutboundCalls],
                      resolverComponent: () => import('@/components/domain/history/HistoryDetailsResolver.vue'),
                      resolverComponentProps: {
                        loaderTitleKey: 'callDetailsInfoLoading.title',
                        loaderDescriptionKey: 'callDetailsInfoLoading.description',
                      },
                    },
                    component: () =>
                      import('@/components/views/reporting/history/calls/outbound/OutboundCallsDetails.vue'),
                  },
                ],
              },
              {
                name: userHistoryCallsInboundRouteName,
                redirect: { name: userHistoryInboundCallsRouteName },
                path: 'inbound',
                alias: '/history/inbound-calls',
                meta: {
                  tags: ['HISTORY_BAR_LIST'],
                  modules: [AppModule.HistoryInboundCalls, AppModule.SentSmsBase],
                },
                children: [
                  {
                    name: userHistoryInboundCallsRouteName,
                    path: '',
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.inboundCalls',
                    },
                    component: () => import('@/components/views/reporting/history/calls/inbound/InboundCalls.vue'),
                  },
                  {
                    name: userHistoryInboundCallsDetailsRouteName,
                    path: ':inboundCallId',
                    props: true,
                    meta: {
                      tabTitle: 'pageTabTitle.user.history.inboundCallDetails',
                      detailsPage: {
                        source: 'router',
                        requestParam: 'inboundCallId',
                        model: InboundCall,
                      } as SingleModelResolverParams,
                      titler: {
                        service: 'RouteTitlerService',
                      },
                      redirectToIfNotFound: { name: userHistoryInboundCallsRouteName },
                      fullHeight: true,
                      resolverComponent: () => import('@/components/domain/history/HistoryDetailsResolver.vue'),
                      resolverComponentProps: {
                        loaderTitleKey: 'callDetailsInfoLoading.title',
                        loaderDescriptionKey: 'callDetailsInfoLoading.description',
                      },
                    },
                    component: () =>
                      import('@/components/views/reporting/history/calls/inbound/InboundCallsDetails.vue'),
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]
